import React from 'react';
import LegalPage from '../../components/LegalPage';

export default function Privacy() {
  return (
    <LegalPage eyebrow="Legal" title="Privacy Policy" updated="July 2025">
      <p>This Privacy Policy explains how Waan Travel Pte. Ltd. (“Waan Travel”, “we”, “us”, “our”), a company incorporated in Singapore with UEN 202418948C and holding STB Travel Agent Licence TA03795, collects, uses and discloses personal data when you visit www.cheapora.com (the “Cheapora” website, operated by Waan Travel Pte. Ltd.). This Policy is intended to be read consistently with the Singapore Personal Data Protection Act 2012 (PDPA).</p>
      <h2>1. Personal data we collect</h2>
      <ul>
        <li>Contact details you submit via our Contact form or Newsletter form (such as name, email and message).</li>
        <li>Search preferences you enter into our search tools (for example, origin, destination, travel dates, travellers). These are used to display comparison results.</li>
        <li>Basic technical information (browser type, device, approximate location) collected automatically to operate and secure the website.</li>
      </ul>
      <h2>2. How we use your personal data</h2>
      <ul>
        <li>To respond to enquiries and provide travel-related information you request.</li>
        <li>To operate the Cheapora comparison experience and, in future, to redirect you to selected travel partners.</li>
        <li>To improve our website and services.</li>
        <li>To comply with applicable legal obligations.</li>
      </ul>
      <h2>3. Sharing with third parties</h2>
      <p>When live travel partner integrations are activated, you may be redirected to a third-party provider to complete a booking. Any personal data you provide directly to that third party is subject to their own privacy policy. Waan Travel does not currently sell your personal data.</p>
      <h2>4. Retention</h2>
      <p>We retain personal data only for as long as reasonably necessary for the purpose for which it was collected, or as required by law.</p>
      <h2>5. Your rights</h2>
      <p>Under the PDPA you may request access to, or correction of, the personal data we hold about you, and you may withdraw consent to our processing of your personal data. To exercise these rights, contact us at <a href="mailto:admin@waantravel.com">admin@waantravel.com</a>.</p>
      <h2>6. Cookies</h2>
      <p>Please see our <a href="/cookies">Cookie Policy</a> for information on how we use cookies and similar technologies.</p>
      <h2>7. Contact</h2>
      <p>Waan Travel Pte. Ltd. · 1 Soon Lee Street, #03-37 Pioneer Centre, Singapore 627605 · <a href="mailto:admin@waantravel.com">admin@waantravel.com</a></p>
    </LegalPage>
  );
}
